"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formRow = _interopRequireDefault(require("../layout/form-row"));

var _default = _formRow.default;
exports.default = _default;